import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from './Icon';

const IconSignal = ({ bars, small = false }) => {
  return (
    <Icon
      name={`signal-${bars}`}
      className={classNames('icon--signal', { small })}
    />
  );
};

IconSignal.propTypes = {
  small: PropTypes.bool,
  bars: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default IconSignal;
